'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// window.location.origin polyfill
if (!window.location.origin) {
  var l = window.location;
  window.location.origin = l.protocol + '//' + l.hostname + (l.port ? ':' + l.port : '');
}

exports.default = function () {};

module.exports = exports['default'];